import React, { useState } from "react";
import AdminAppBar from "../../adminComponents/AdminAppBar";
import { Sidebar } from "primereact/sidebar";
import CustomHeading from "../../common/CustomHeading";
import CustomButton from "../../common/CustomButton";
import CustomTable from "../../common/CustomTable";
import { BiEdit } from "react-icons/bi";
import TeamInfoSidebar from "./TeamInfoSidebar";
import CustomSearch from "../../common/CustomSearch";
import { getIcons } from "../../Constant/Constant";
import TeamFormModal from "./TeamFormModal";
import useTeam from "../../../hooks/useTeam";
import { ToastContainer } from "react-toastify";

const TeamList = () => {
  const {
    teamName,
    setTeamName,
    isOpen,
    setIsOpen,
    handleSubmit,
    getTeamInfo,
    teamInfo,
    handleUpdate,
    teamCount,
    teamList,
    pageSize,
    searchTerm,
    nextPageToken,
    prevPageToken,
    currentPage,
    hasMore,
    loading,
    handleSearchSubmit,
    handleSearchChange,
    handlePageChange,
    handlePageSizeChange,
    refreshData,
    
  } = useTeam();

  const handleEditClick = (record) => {
    getTeamInfo(record.id);
    setVisibleForm(true);
  };

  const [visibleForm, setVisibleForm] = useState(false);

  const columns = [
    {
      key: "name",
      title: "Team",
      render: (text) => (
        <div
          title={text.replace(/\b\w/g, (char) => char.toUpperCase())}
          className="text-blue-500 truncate cursor-pointer text-center"
        >
          {text.replace(/\b\w/g, (char) => char.toUpperCase())}
        </div>
      ),
    },
    {
      key: "members",
      title: "Members",
      render: (text) => <div className="truncate">{text}</div>,
    },
    {
      key: "BOD",
      title: "BOD",
      render: (text) => <div className="truncate">{text}</div>,
    },
    {
      key: "MD",
      title: "MD",
      render: (text) => <div className="truncate">{text}</div>,
    },
    {
      key: "Action",
      title: "Action",
      render: (_, record) => (
        <div
          onClick={() => handleEditClick(record)}
          className="flex justify-center items-center h-full cursor-pointer"
        >
          <BiEdit className="text-blue-500 text-lg" />
        </div>
      ),
    },
  ];

  const handleCreateClick = () => {
    setIsOpen(true);
  };

  return (
    <div className="bg-appGrayBackground pb-7">
       <AdminAppBar />
      <ToastContainer />
      <div className="pt-28 px-6  ">
        <div className="flex items-center justify-between">
          <CustomHeading
            title={
              <>
                Teams <span className="text-customGreen">({teamCount})</span>
              </>
            }
            isIcon={true}
          />
          <div className="flex items-center gap-4">
            <CustomSearch
              placeholder={"Search Teams"}
              searchTerm={searchTerm}
              handleSearchSubmit={handleSearchSubmit}
              handleSearchChange={handleSearchChange}
            />
            <CustomButton label={"Create Team"} onClick={handleCreateClick} />
          </div>
        </div>

        <div className="w-full mt-[50px]">
          <CustomTable
            columns={columns}
            data={teamList}
            isPagination={true}
            pageSize={pageSize}
            imageNotFound={getIcons().teamEmpty}
            onPageChange={handlePageChange}
            onPageSizeChange={handlePageSizeChange}
            currentPage={currentPage}
            nextId={nextPageToken}
            prevId={prevPageToken}
            hasMore={hasMore}
            loading={loading}
          />
        </div>

        <TeamFormModal
          isOpen={isOpen}
          onClose={() => {
            setIsOpen(false);
            setTeamName("");
          }}
          handleSubmit={async () => {
            await handleSubmit();
            refreshData();
          }}
          setTeamName={setTeamName}
          teamName={teamName}
          loading={loading}
        />

        <Sidebar
          header={
            <div className="flex items-center justify-between w-full">
              <span className="font-semibold text-lg text-customGreen">
                {"Team Information"}
              </span>
            </div>
          }
          visible={visibleForm}
          onHide={() => {
            setVisibleForm(false);
            setTeamName("");
          }}
          style={{ width: "500px" }}
          position="right"
          className="p-sidebar-md"
        >
          <TeamInfoSidebar
            teamInfo={teamInfo}
            setTeamName={setTeamName}
            teamName={teamName}
            loading={loading}
            handleUpdate={async (teamId, teamName) => {
              await handleUpdate(teamId, teamName);
              refreshData();
              setVisibleForm(false);
              setTeamName("");
            }}
          />
        </Sidebar>
      </div>
    </div>
  );
};

export default TeamList;